import { NgModule } from '@angular/core';
import { EinConfigurationScreenComponent } from './ein-configuration.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EinConfigurationRouter } from './ein-configuration.router';
import { EinConfigurationEffects } from './state/ein-configuration.effects';
import { reducers } from './state/ein-configuration.selectors';

@NgModule({
  imports: [
    EinConfigurationRouter,
    StoreModule.forFeature('einConfiguration', reducers),
    EffectsModule.forFeature([EinConfigurationEffects]),
  ],
  declarations: []
})
export class EinConfigurationScreenModule { }